import React, { useState, useEffect } from "react";
import { Input, TextArea } from "components";
import NumberFormat from "react-number-format";
import { FlexRow, Button, LineButton, FlexColumn } from "appStyles";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import styled, { css } from "react-emotion";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

import Modal from "@material-ui/core/Modal";
import { withStyles } from "@material-ui/core/styles";
import CreateIcon from "@material-ui/icons/Create";

import Tooltip from "@material-ui/core/Tooltip";
import {
  withRedux,
  priceToDollars,
  formatDollarsToCents,
  isMobileDevice,
} from "helpers";
import WebIcon from "../../pages/Web/WebIcon";

import { toast } from "react-toastify";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MoreMenu from "./MoreMenu";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#F17F7F",
    },
    secondary: {
      main: "#88d1d4",
    },
  },
  overrides: {
    // Style sheet name ⚛️
    MuiTablePagination: {
      // Name of the rule
      actions: {
        // Some CSS
        marginLeft: "0px",
      },
    },
    MuiTableContainer: {
      root: {
        flex: 1,
        height: "100%",
        overflowY: "auto",

        display: "flex",
        width: "100%",
      },
    },
    MuiTableSortLabel: {
      root: {
        color: "#89D2D3 !important",
      },
    },
  },
});

const bodyStyle = css`
  width: 100%;
`;

const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;
const inlineBlock = css`
  display: inline-block;
`;

const headerText = css`
  text-align: center;
  font-size: 1.5em;
  margin: 0px;
  display: inline-block;
  @media only screen and (min-width: 768px) {
    text-align: center;
    margin: 0px;
  }
`;

const sectionText = css`
  text-align: left;
  font-size: 1em;
  margin: 0px;
  margin-bottom: 20px;
  @media only screen and (min-width: 768px) {
    text-align: left;
    font-size: 1.5em;
    margin: 0px;
    margin-bottom: 20px;
  }
`;

const arrowStyle = css`
  font-size: 1.75em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const headerContainer = css`
  height: 25px;
  align-items: center;
  margin: 10px 0px;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    height: 25px;
    align-items: center;
    margin: 20px 0px;
    justify-content: center;
  }
`;

const inputStyle = css`
  width: 30%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

const iconStyle = css`
  margin-right: 10px;
`;
const boldButton = css`
  display: inline-block;
  width: 100px;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
`;

const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const titleStyle = css`
  white-space: nowrap;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  margin-right: 10px;
  /* margin-top: 10px; */
  margin-bottom: 5px;
`;

const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
`;

const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 20px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;

const H3 = styled("h3")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 20px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;

const buttonStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  display: inline-flex;
  align-items: center;
  border-radius: 5.5px;
`;

String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

const discountText = `To add a discount, enter a negative value for “Price Per Item”. The discount will show up as a line item and will the inputted value will be deducted from the invoice total.`;

const createTempId = (length) => {
  var result = "";
  var characters = "0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 300,
    fontSize: "14px",
  },
}));

const InvoiceDetails = (props) => {
  const {
    activeApp,
    platformInfo: { status: user },
    invoices,
    activeEditor,
    actions: { setInvoices },
  } = props;
  // console.log("invoice page props");
  // console.dir(props);
  const accessToken = props.location.state
    ? props.location.state.accessToken
    : null;

  // console.log("accessToken: " + accessToken);

  // console.log("InvoiceDetails loading user...");
  // console.dir(user);
  const classes = useStyles();

  // console.log("active editor: " + activeEditor);

  // console.log("its the active invoice!\n\n");

  const activeInvoice = invoices[activeEditor];

  // http://localhost:3300/butterchickenshop/invoices?id=lAGn-49e206b99dcc4a4ab83cca5d98a76f95

  // console.dir(activeInvoice);
  const isMob = isMobileDevice();

  const DRAFT = activeInvoice.status === "DRAFT";
  const OPEN = activeInvoice.status === "OPEN";
  const PAID = activeInvoice.status === "PAID";
  const VOID = activeInvoice.status === "VOID";

  const [showInvoiceItemModal, setShowInvoiceItemModal] = useState(false);

  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  const copy = () => {
    var input = document.createElement("input");
    input.setAttribute("value", activeInvoice.invoiceLink);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
    notify("copy");

    return result;
  };
  const Msg = (props) => {
    const { message } = props;
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ marginRight: "10px" }}>
            {" "}
            <WebIcon
              iconName={"checkMark"}
              useColor={true}
              size={"16px"}
              hover={false}
              className={inlineBlock}
              customColor={"#4caf50"}
            />
          </div>
          <p>{message}</p>
        </div>
      </div>
    );
  };
  const [invoiceItemError, setInvoiceItemError] = useState("");
  const [showSendConfirmationModal, setShowSendConfirmationModal] =
    useState(false);

  const [showVoidConfirmationModal, setShowVoidConfirmationModal] =
    useState(false);

  const [tempInvoiceItem, setTempInvoiceItem] = useState({
    name: "",
    pricePerItem: 0,
    quantity: 0,
    id: createTempId(20),
  });

  // console.log("invoice item");
  // console.dir(tempInvoiceItem);

  const [edit, setEdit] = useState(null);

  const {
    id,
    name,
    description,
    subtotal,
    status,
    orderCustomerInfo: { firstName, lastName, email, phone },
  } = activeInvoice;

  const isNewInvoice = id === "newInvoice";

  const notify = (action) => {
    // console.log("rendering a toast");
    switch (action) {
      case "created":
        toast(
          Msg({
            message:
              "Success! Invoice has been created. You may now send it to your customer.",
          }),
          {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "copy":
        toast(Msg({ message: "Copied Invoice Link" }), {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        break;
      case "saved":
        toast(Msg({ message: "Success! Saved Invoice." }), {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        break;
      case "sent":
        toast(Msg({ message: "Success! Sent Invoice to Customer." }), {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        break;
      default:
        return null;
    }
  };

  const goBack = () => {
    if (accessToken) {
      // console.log("going back to accessToken url");
      props.history.push(
        `/app/${activeInvoice.appId}/admin/invoices?accessToken=${accessToken}`
      );
    } else {
      props.history.push(`/app/${activeInvoice.appId}/admin/invoices`);
    }
  };

  const rehydrateInvoice = (invoice) => {
    props.actions.updateInvoice({
      ...activeInvoice,
      invoiceItems: invoice.invoiceItems,
      subtotal: invoice.subtotal,
    });
  };

  const removeTempIDs = () => {
    // console.log("removing temp keys...");
    activeInvoice.invoiceItems.map((item) => {
      if (isNewInvoiceItem(item.id)) delete item.id;
    });
  };

  const createInvoiceHelper = async () => {
    removeTempIDs();
    props.actions
      .createInvoice(activeInvoice.appId, activeInvoice, accessToken)
      .then((invoice) => {
        // console.log("SUCCESS! - got invoice back from API");
        // console.dir(invoice);
        let invoicesObject = JSON.parse(JSON.stringify(invoices));
        invoicesObject[invoice.id] = invoice;
        setInvoices(invoicesObject);
        props.actions.updateActiveEditor(invoice.id);
        notify("created");
      });
  };

  const deleteInvoice = async () => {
    props.actions
      .deleteInvoice(activeInvoice.appId, activeInvoice.id, accessToken)
      .then((invoice) => {
        // console.log("deleted invoice: " + activeInvoice.id);
        let invoicesObject = JSON.parse(JSON.stringify(invoices));
        invoicesObject[invoice.id] = invoice;
        setInvoices(invoicesObject);
      });

    props.actions.updateActiveEditor("newInvoice");
    goBack();
  };

  const toggleVoidConfirmationModal = () => {
    setShowVoidConfirmationModal(!showVoidConfirmationModal);
  };

  const toggleSendConfirmationModal = () => {
    setShowSendConfirmationModal(!showSendConfirmationModal);
  };

  const renderVoidConfirmationModal = () => {
    if (!showVoidConfirmationModal) return null;

    return (
      <Modal
        open={showVoidConfirmationModal}
        padding="1em"
        onClose={toggleVoidConfirmationModal}
        style={{
          top: isMob ? "1%" : "25%",
          width: isMob ? "100%" : "400px",

          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            height: "auto",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
          }}
        >
          <H2 style={{ marginBottom: "15px" }}>Void Invoice?</H2>
          <P fontSize="1em">
            Are you sure you'd like to void this invoice? This action can't be
            undone!
          </P>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <Button background="#FF5353" onClick={toggleVoidConfirmationModal}>
              Cancel
            </Button>
            <Button onClick={deleteInvoice}>Void Invoice</Button>
          </div>
        </div>
      </Modal>
    );
  };

  const renderSendConfirmationModal = () => {
    if (!showSendConfirmationModal) return null;
    const {
      orderCustomerInfo: { fullName, email, phone },
    } = activeInvoice;

    return (
      <Modal
        open={showSendConfirmationModal}
        padding="1em"
        onClose={toggleSendConfirmationModal}
        style={{
          top: isMob ? "1%" : "25%",
          width: isMob ? "100%" : "400px",

          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            height: "auto",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
          }}
        >
          <H2 style={{ marginBottom: "15px" }}>Send Invoice?</H2>
          <P fontSize="1em">
            Are you sure you want to send this invoice to {fullName}? We will
            email them at {email} and send them a text at {phone}.
          </P>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <Button background="#FF5353" onClick={toggleSendConfirmationModal}>
              Cancel
            </Button>
            <Button onClick={sendInvoice}>Send Invoice</Button>
          </div>
        </div>
      </Modal>
    );
  };

  const sendInvoice = async () => {
    props.actions
      .sendInvoice(activeInvoice.appId, activeInvoice.id, accessToken)
      .then((invoice) => {
        // console.log("sent invoice: " + activeInvoice.id);
        notify("sent");
        toggleSendConfirmationModal();
      });
  };

  // (appId, invoice, id, accessToken)

  const updateInvoice = async () => {
    props.actions
      .saveInvoice(activeInvoice.appId, activeInvoice, accessToken)
      .then((invoice) => {
        // console.log("saved invoice: " + activeInvoice.id);
        notify("saved");
      });
  };

  const updateCustomerInfo = (field) => (value) => {
    const newCustomerInfoObject = {
      ...activeInvoice.orderCustomerInfo,
      [field]: value,
    };

    props.actions.updateInvoice({
      ...activeInvoice,
      orderCustomerInfo: newCustomerInfoObject,
    });
  };

  const update = (field) => (value) => {
    // console.log("^^^^^^^ updating invoice");
    props.actions.updateInvoice({
      ...activeInvoice,
      [field]: value,
    });
  };

  const renderBackArrow = () => {
    return (
      <div className={storeContainer}>
        <FontAwesomeIcon
          className={arrowStyle}
          icon="arrow-left"
          onClick={goBack}
        />
      </div>
    );
  };

  const renderCustomerDetails = () => {
    return (
      <div className={storeContainer} style={{ marginTop: "40px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <H3 className={sectionText}>Customer</H3>
          <span className={titleStyle}>First Name</span>
          <div style={{ marginBottom: "15px" }}>
            <Input
              field="John"
              name="firstName"
              // validateInput="true"
              defaultValue={firstName}
              onChange={updateCustomerInfo("firstName")}
              disabled={VOID || PAID}
              // textColor={VOID ? "gray" : "rgb(31, 55, 71)"}
              // background={VOID ? "lightgrey" : "white"}
              width={isMob ? "100%" : "400px"}
            />
          </div>
          <span className={titleStyle}>Last Name</span>
          <div style={{ marginBottom: "15px" }}>
            <Input
              field="Doe"
              name="lastName"
              // validateInput="true"
              defaultValue={lastName}
              onChange={updateCustomerInfo("lastName")}
              disabled={VOID || PAID}
              // textColor={VOID ? "gray" : "rgb(31, 55, 71)"}
              // background={VOID ? "lightgrey" : "white"}
              width={isMob ? "100%" : "400px"}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <span className={titleStyle}>Email</span>
          <div style={{ marginBottom: "15px" }}>
            <Input
              field="johndoe@gmail.com"
              name="Promo Code"
              // validateInput="true"
              defaultValue={email}
              onChange={updateCustomerInfo("email")}
              disabled={VOID || PAID}
              // textColor={VOID ? "gray" : "rgb(31, 55, 71)"}
              // background={VOID ? "lightgrey" : "white"}
              width={isMob ? "100%" : "400px"}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <span className={titleStyle}>Phone</span>
          <div style={{ marginBottom: "15px" }}>
            <Input
              field="5105551234"
              name="Promo Code"
              // validateInput="true"
              defaultValue={phone}
              onChange={updateCustomerInfo("phone")}
              disabled={VOID || PAID}
              // textColor={VOID ? "gray" : "rgb(31, 55, 71)"}
              // background={VOID ? "lightgrey" : "white"}
              width={isMob ? "100%" : "400px"}
            />
          </div>
        </div>
      </div>
    );
  };

  const toggleInvoiceItemModal = () => {
    setShowInvoiceItemModal(!showInvoiceItemModal);
  };

  const addInvoiceItem = () => {
    // console.log("adding a new invoice item....");
    // console.dir(activeInvoice.invoiceItems);
    if (tempInvoiceItem.name === "" || tempInvoiceItem.quantity === 0) {
      setInvoiceItemError("Invoice item requires a name and quantity.");
      return;
    }
    if (activeInvoice.id != "newInvoice") {
      delete tempInvoiceItem.id;
      props.actions
        .createInvoiceItem(
          activeInvoice.appId,
          activeInvoice.id,
          tempInvoiceItem,
          accessToken
        )
        .then((invoiceObj) => {
          rehydrateInvoice(invoiceObj);
        });
    } else {
      activeInvoice.invoiceItems.push(tempInvoiceItem);
      props.actions.updateInvoice({
        ...activeInvoice,
      });
    }
    // const newInvoiceItemsArr = activeInvoice.invoiceItems.push(tempInvoiceItem);
    // console.dir(newInvoiceItemsArr);

    setTempInvoiceItem({
      name: "",
      pricePerItem: 0,
      quantity: 0,
      id: createTempId(20),
    });
    setInvoiceItemError("");
    toggleInvoiceItemModal();
  };

  const isNewInvoiceItem = (id) => {
    if (id) return typeof id === "string" && id.toString().length === 20;
    return (
      typeof tempInvoiceItem.id === "string" &&
      tempInvoiceItem.id.toString().length === 20
    );
  };

  const updateInvoiceItem = async () => {
    if (tempInvoiceItem.name === "" || tempInvoiceItem.quantity === 0) {
      setInvoiceItemError("Invoice item requires a name and quantity.");
      return;
    }

    if (edit != null) {
      activeInvoice.invoiceItems[edit] = tempInvoiceItem;
      setEdit(null);
    } else {
      props.actions
        .saveInvoiceItem(
          activeInvoice.appId,
          activeInvoice.id,
          tempInvoiceItem,
          accessToken
        )
        .then((invoiceObj) => {
          // console.log("got back saved object");
          // console.dir(invoiceObj);
          rehydrateInvoice(invoiceObj);
        });
    }

    setInvoiceItemError("");

    toggleInvoiceItemModal();
  };

  const deleteInvoiceItem = () => {
    // console.dir(tempInvoiceItem);

    let newState = activeInvoice;

    var newList = newState.invoiceItems.filter((x) => {
      return x.id != tempInvoiceItem.id;
    });
    newState.invoiceItems = newList;

    props.actions.updateInvoice({ ...newState });

    // delete for existing store item
    if (!isNewInvoiceItem() && activeInvoice.id != "newInvoice") {
      // console.log("deleting item for existing invoice");

      props.actions
        .deleteInvoiceItem(
          activeInvoice.appId,
          activeInvoice.id,
          tempInvoiceItem.id,
          accessToken
        )
        .then((invoiceObj) => {
          // console.log("got back deleted object");
          // console.dir(invoiceObj);
          rehydrateInvoice(invoiceObj);
        });
    }

    toggleInvoiceItemModal();

    // updateInvoice();
  };

  const updateTempInvoiceItem = (field) => (value) => {
    if (field === "pricePerItem") {
      value = formatDollarsToCents(value["value"]);
    }
    setTempInvoiceItem({
      ...tempInvoiceItem,
      [field]: value,
    });
  };

  const getPricePerItem = () => {
    // console.log(tempInvoiceItem.pricePerItem);
    // console.log(tempInvoiceItem.quantity);
    return tempInvoiceItem.pricePerItem * tempInvoiceItem.quantity;
  };

  const renderInvoiceItemModal = () => {
    if (!showInvoiceItemModal) return;
    return (
      <Modal
        open={showInvoiceItemModal}
        onClose={toggleInvoiceItemModal}
        style={{
          top: isMob ? "1%" : "25%",
          right: isMob ? "1%" : "0%",
          left: isMob ? "1%" : "0%",
          width: isMob ? "96%" : "50%",

          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            height: "auto",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {tempInvoiceItem.createdDate || edit != null ? (
              <H2
                style={{
                  marginBottom: "15px",
                  display: "inline-block",
                  margin: "0px",
                }}
              >
                Edit Line Item
              </H2>
            ) : (
              <H2
                style={{
                  marginBottom: "15px",
                  display: "inline-block",
                  margin: "0px",
                }}
              >
                Create Line Item
              </H2>
            )}
            {isMobileDevice ? (
              <Tooltip
                title={discountText}
                classes={{ tooltip: classes.customWidth }}
                open={tooltipIsOpen}
                onOpen={() => setTooltipIsOpen(true)}
                onClose={() => setTooltipIsOpen(false)}
              >
                <span
                  style={{ textDecoration: "underline" }}
                  onClick={() => setTooltipIsOpen(!tooltipIsOpen)}
                >
                  Add Discount?
                </span>
              </Tooltip>
            ) : (
              <Tooltip
                title={discountText}
                classes={{ tooltip: classes.customWidth }}
              >
                <span style={{ textDecoration: "underline" }}>
                  Add Discount?
                </span>
              </Tooltip>
            )}
          </div>
          <div
            style={{
              margin: "10px 0px",
              fontSize: "0.875rem",
            }}
          >
            <p
              style={{
                margin: "10px 0px",
                fontSize: "1rem",
              }}
            >
              Item Name (Required)
            </p>

            <Input
              name="Name"
              field="Wedding Cake"
              defaultValue={tempInvoiceItem.name}
              onChange={updateTempInvoiceItem("name")}
              width={isMob ? "100%" : "362px"}
            />

            <p
              style={{
                margin: "10px 0px",
                fontSize: "1rem",
              }}
            >
              Price Per Item
            </p>

            <NumberFormat
              placeholder="$0.00"
              thousandSeparator={true}
              prefix={"$"}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={true}
              allowLeadingZeros={false}
              defaultValue={
                tempInvoiceItem.pricePerItem
                  ? priceToDollars(tempInvoiceItem.pricePerItem)
                  : null
              }
              onValueChange={updateTempInvoiceItem("pricePerItem")}
              className={inputStyle}
              style={{
                width: "100px",
              }}
            />
            <p
              style={{
                margin: "10px 0px",
                fontSize: "1rem",
              }}
            >
              Quantity (Required)
            </p>
            <Input
              name="Name"
              field="5"
              type="number"
              defaultValue={tempInvoiceItem.quantity}
              onChange={updateTempInvoiceItem("quantity")}
              width={isMob ? "100%" : "362px"}
            />
          </div>
          <p> Total: {priceToDollars(getPricePerItem())}</p>
          <p style={{ color: "red" }}>{invoiceItemError}</p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <a
              onClick={deleteInvoiceItem}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Delete
            </a>
            {tempInvoiceItem.createdDate || edit != null ? (
              <Button
                onClick={updateInvoiceItem}
                background="#89D2D3"
                className={buttonStyle}
                style={{ marginRight: "0px" }}
              >
                Save
              </Button>
            ) : (
              <Button
                onClick={addInvoiceItem}
                background="#89D2D3"
                className={buttonStyle}
                style={{ marginRight: "0px" }}
              >
                Create Invoice Item
              </Button>
            )}
          </div>
        </div>
      </Modal>
    );
  };

  const editInvoiceItem = (item, idx) => {
    // console.log("editing invoice item...");
    setTempInvoiceItem(item);
    if (!item.createdDate) setEdit(idx);
    toggleInvoiceItemModal();
  };

  const addNewInvoiceItem = () => {
    // console.log("adding new invoice item");
    setTempInvoiceItem({
      name: "",
      pricePerItem: 0,
      quantity: 0,
      id: createTempId(20),
    });
    toggleInvoiceItemModal();
  };

  const calculateTempSubtotal = () => {
    if (!activeInvoice.invoiceItems) return;
    let subtotal = 0;
    activeInvoice.invoiceItems.map((item) => {
      subtotal += item.pricePerItem * item.quantity;
    });

    return subtotal;
  };
  const hasNewTempInvoiceItems = () => {
    // console.log("checking for temp invoice items");
    let bool = false;
    if (!activeInvoice.invoiceItems) return bool;
    activeInvoice.invoiceItems.map((item) => {
      if (isNewInvoiceItem()) bool = true;
    });
    return bool;
  };

  const renderInvoiceItems = () => {
    if (!activeInvoice.invoiceItems) return null;
    let subtotalToRender = subtotal;

    if (isNewInvoice || hasNewTempInvoiceItems()) {
      subtotalToRender = calculateTempSubtotal();
    }

    return (
      <div
        className={storeContainer}
        style={{ marginBottom: "20px", marginTop: "25px" }}
      >
        {renderInvoiceItemModal()}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <H3 className={sectionText} style={{ marginBottom: "30px" }}>
            Line Items
          </H3>
          {activeInvoice.invoiceItems.map((item, idx) => {
            return (
              <div
                key={item.name}
                style={{
                  marginBottom: "30px",
                  borderBottom: "1px solid rgba(224, 224, 224, 1)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 0px",
                  }}
                >
                  <div style={{ width: "65%" }}>
                    <span>
                      {item.quantity} x {item.name} (
                      {priceToDollars(item.pricePerItem)} each)
                    </span>
                  </div>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    {priceToDollars(item.quantity * item.pricePerItem)}
                    {!VOID && !PAID && (
                      <a
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginLeft: "10px",
                        }}
                        onClick={() => editInvoiceItem(item, idx)}
                      >
                        <CreateIcon
                          style={{ marginRight: "5px" }}
                          fontSize="small"
                        ></CreateIcon>
                      </a>
                    )}
                  </span>
                </div>
                {/* <p style={{ textAlign: "end" }}></p> */}
              </div>
            );
          })}
          <div
            style={{
              marginBottom: "5px",
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.15rem",
            }}
          >
            {!VOID && !PAID && (
              <div
                style={{
                  marginBottom: "5px",
                  textAlign: "start",
                }}
              >
                <a
                  style={{
                    cursor: VOID ? "default" : "pointer",
                    // textDecoration: "underline",
                    color: "#89D2D3",
                    // fontWeight: "bold",
                  }}
                  onClick={addNewInvoiceItem}
                >
                  Add Item
                </a>
              </div>
            )}
            <span style={{ marginRight: "25px" }}>
              Total: {priceToDollars(subtotalToRender)}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderInvoiceDetails = () => {
    return (
      <div
        className={storeContainer}
        style={{ marginTop: "40px", marginBack: "25px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {" "}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "40px",
            }}
          >
            <H3 className={sectionText} style={{ marginBottom: "0px" }}>
              Invoice Details{" "}
            </H3>{" "}
            {!isNewInvoice && status && typeof status === "string" ? (
              <span
                style={{
                  fontSize: "0.9375rem",
                  fontWeight: "normal",
                }}
              >
                <strong>Status</strong>: {status.toProperCase()}
              </span>
            ) : (
              ""
            )}
          </div>
          {/* <div style={{ marginBottom: "20px", marginTop: "20px" }}>
          
          </div> */}
          <span className={titleStyle}>Invoice Name</span>
          <div style={{ marginBottom: "15px" }}>
            <Input
              field="Wedding Cake Invoice"
              name="Promo Code"
              // validateInput="true"
              defaultValue={name}
              onChange={update("name")}
              disabled={VOID || PAID}
              // textColor={VOID ? "gray" : "rgb(31, 55, 71)"}
              // background={VOID ? "lightgrey" : "white"}
              width={isMob ? "100%" : "400px"}
            />
          </div>
          <span className={titleStyle}>Memo</span>
          <TextArea
            height="5rem"
            placeholder="Thanks for your business!"
            marginTop="0px"
            text={description}
            onChange={update("description")}
            marginBottom="20px"
            disabled={VOID || PAID}
            // textColor={VOID ? "gray" : "rgb(31, 55, 71)"}
            // background={VOID ? "lightgrey" : "white"}
            width={isMob ? "100%" : "400px"}
          />
        </div>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div
        className={storeContainer}
        style={{
          position: "sticky",
          top: "0px",
          borderBottom: "1px solid rgb(190, 226, 226)",
          zIndex: "10",
          display: "block",
          background: "white",
        }}
      >
        {renderSendConfirmationModal()}
        {renderVoidConfirmationModal()}
        <FlexRow
          style={{
            justifyContent: "space-between",
            height: "auto",
          }}
        >
          <H3 className={headerText}>
            {isNewInvoice ? "New Invoice" : "Invoice #" + id}
          </H3>
          {!isNewInvoice && (
            <MoreMenu
              activeInvoice={activeInvoice}
              copy={copy}
              toggleVoidConfirmationModal={toggleVoidConfirmationModal}
            />
          )}
        </FlexRow>
        <FlexRow
          style={{
            justifyContent: isNewInvoice ? "flex-end" : "space-between",
            height: "auto",
          }}
        >
          {isNewInvoice && (
            <Button
              className={boldButton}
              background="#89D2D3"
              onClick={createInvoiceHelper}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // margin: "10px 20px",
                textAlign: "center",

                width: "auto",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              Save
            </Button>
          )}

          {(DRAFT || OPEN) && (
            <Button
              className={boldButton}
              background="#89D2D3"
              onClick={updateInvoice}
              style={{
                display: "inline-flex",
                alignItems: "center",
                marginLeft: "0px",
                textAlign: "center",
                width: "auto",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              Save
            </Button>
          )}

          {DRAFT && (
            <Button
              className={boldButton}
              background="#85B49F"
              onClick={toggleSendConfirmationModal}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // margin: "10px 20px",
                textAlign: "left",
                width: "165px",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              Send to Customer
            </Button>
          )}
        </FlexRow>
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <div
        className={storeContainer}
        style={{
          position: "sticky",
          top: "0px",
          borderBottom: "1px solid rgb(190, 226, 226)",
          zIndex: "10",
          display: "block",
          background: "white",
        }}
      >
        {renderSendConfirmationModal()}
        {renderVoidConfirmationModal()}
        <H3 className={headerText}>
          {isNewInvoice ? "New Invoice" : "Invoice #" + id}
        </H3>
        <FlexRow
          style={{
            justifyContent: "space-between",
            height: "auto",
          }}
        >
          {isNewInvoice && (
            <Button
              className={boldButton}
              background="#89D2D3"
              onClick={createInvoiceHelper}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // margin: "10px 20px",
                textAlign: "center",

                width: "auto",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              Save
            </Button>
          )}

          {(DRAFT || OPEN) && (
            <Button
              className={boldButton}
              background="#89D2D3"
              onClick={updateInvoice}
              style={{
                display: "inline-flex",
                alignItems: "center",
                marginLeft: "0px",
                textAlign: "center",
                width: "auto",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              Save
            </Button>
          )}

          {DRAFT && (
            <Button
              className={boldButton}
              background="#85B49F"
              onClick={toggleSendConfirmationModal}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // margin: "10px 20px",
                textAlign: "left",
                width: "165px",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              Send to Customer
            </Button>
          )}

          {!isNewInvoice && (
            <MoreMenu
              activeInvoice={activeInvoice}
              copy={copy}
              toggleVoidConfirmationModal={toggleVoidConfirmationModal}
            />
          )}
        </FlexRow>
      </div>
    );
  };

  const scrollTo = (ref) => {
    if (ref && props.history.action === "PUSH" /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
      props.history.action = "POP";
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <a ref={scrollTo}></a>
      <div>
        {renderBackArrow()}
        <div
          className={storeContainer}
          style={{
            maxWidth: "900px",
            margin: "auto",
            marginTop: "10px",
            marginBottom: "50px",
          }}
        >
          {/* {renderButtons()} */}
          {renderHeader()}
          {renderInvoiceDetails()}
          {renderCustomerDetails()}
          {renderInvoiceItems()}
        </div>
      </div>
      <div>
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          transition={Zoom}
          bodyClassName={bodyStyle}
        />
      </div>
    </ThemeProvider>
  );
};

export default withRedux(InvoiceDetails);
